module.exports = __webpack_public_path__ + "img/dataMiddleground-charafunction1.0d5c7586.png";